export class SetPassword {
    current_password: string;
    new_password: string;
    re_new_password: string;
}
